module.exports = __webpack_public_path__ + "img/u1237.4cad5b46.png";